.quickActions {
	display: flex;
	align-items: center;
	gap: 0.5rem;
	flex-wrap: wrap;
}

.btnLabel {
	display: inline;
}

.hectares {
	font-size: 0.75rem;
	opacity: 0.7;
	font-weight: 400;
	margin-left: 0.25rem;
}

.subtitle {
	margin: 0;
	margin-left: 0.5rem;
	font-size: 0.75rem;
	opacity: 0.7;
	font-weight: 400;
}
